<script>
export default {
  props: {
    markRequired: {
      type: Boolean,
      default: false,
    },
    size: { type: String, default: 'sm' },
    label: { type: String, default: '' },
  },
}
</script>
<template>
  <div
    :class="{
      [$style.eLabel]: true,
      [$style.labelMargin]: size === 'md',
      [$style.formFieldLabel]: size === 'sm',
    }"
  >
    {{ label }}
    <span v-if="markRequired" class="text-danger">*</span>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.eLabel {
  margin: 0.325rem 0;
  display: inline-block;
}
.labelMargin {
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}
.formFieldLabel {
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
</style>
